import React from 'react';

/**
 * Formats advisor names to display ® symbols as superscript
 * @param name - The advisor name with potential designation symbols
 * @returns React element with formatted name
 */
export const formatAdvisorName = (name: string): React.ReactElement => {
  // Split the name by ® symbol
  const parts = name.split('®');

  if (parts.length === 1) {
    // No ® symbol found, return the name as is
    return <>{name}</>;
  }

  // Build the formatted name with superscript ® symbols
  const formattedElements: React.ReactNode[] = [];

  parts.forEach((part, index) => {
    formattedElements.push(part);

    // Add superscript ® after each part except the last one
    if (index < parts.length - 1) {
      formattedElements.push(
        <sup key={`sup-${index}`} style={{ fontSize: '0.7em' }}>®</sup>
      );
    }
  });

  return <>{formattedElements}</>;
};

/**
 * Formats advisor names for HTML email templates
 * @param name - The advisor name with potential designation symbols
 * @returns HTML string with formatted name
 */
export const formatAdvisorNameForEmail = (name: string): string => {
  // Replace ® with HTML superscript tag
  return name.replace(/®/g, '<sup style="font-size: 0.7em;">®</sup>');
};